import { FilterType, WaitingRoomStatus } from "src/api/types";
import {
  ASSIGNEE_FIRST_NAME,
  ASSIGNEE_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_ID,
  PATIENT_LAST_NAME,
  QUEUE_TYPE,
  STATUS,
  WAITING_ROOM_ID,
} from "src/constants/searchParams";

export const queueTypes: { name: string; value: string }[] = [
  { name: "Lead Provider", value: "Lead Provider" },
  { name: "Provider", value: "Provider" },
  { name: "Health Navigator", value: "Coordinator" },
];

export const statuses: WaitingRoomStatus[] = [
  "ADDED",
  "ASSIGNED",
  "COMPLETED",
  "CANCELED",
];

export const filters: FilterType[] = [
  {
    name: WAITING_ROOM_ID,
    placeholder: "Room ID",
    type: "text",
  },
  {
    name: PATIENT_ID,
    placeholder: "Patient ID",
    type: "text",
  },
  {
    name: PATIENT_FIRST_NAME,
    placeholder: "Patient first name",
    type: "text",
  },
  {
    name: PATIENT_LAST_NAME,
    placeholder: "Patient last name",
    type: "text",
  },
  {
    name: ASSIGNEE_FIRST_NAME,
    placeholder: "Assignee first name",
    type: "text",
  },
  {
    name: ASSIGNEE_LAST_NAME,
    placeholder: "Assignee last name",
    type: "text",
  },

  {
    name: QUEUE_TYPE,
    placeholder: "Queue Type",
    type: "select",
    objectValues: queueTypes,
  },
  {
    name: STATUS,
    placeholder: "Status",
    type: "multiselect",
    values: statuses,
  },
];
